import React from "react";

const AnsweredPercentage = ({ answeredCount, notAnsweredCount, answeredPct, circumference, dashOffset }) => {
  return (
    <div className="card">
      <div className="card-head">
        <h2>Answered Percentage</h2>
      </div>
      <div className="donut-wrap">
        <svg width="150" height="150" viewBox="0 0 150 150">
          <circle cx="75" cy="75" r="58" fill="none" stroke="#E5E7EB" strokeWidth="18" />
          <circle
            cx="75"
            cy="75"
            r="58"
            fill="none"
            stroke="#17B26A"
            strokeWidth="18"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            transform="rotate(-90 75 75)"
          />
          <text x="75" y="70" textAnchor="middle" className="donut-center" fontSize="26" fontWeight="700" fill="#12312D">
            {answeredPct}%
          </text>
          <text x="75" y="90" textAnchor="middle" fontSize="11" fill="#7C8B85" fontFamily="Inter">
            answered
          </text>
        </svg>
        <div className="donut-legend">
          <div className="item">
            <span className="sw" style={{ background: "#17B26A" }}></span> Answered
          </div>
          <div className="item">
            <span className="sw" style={{ background: "#E5E7EB", border: "1px solid #C7CBD1" }}></span> No answer
          </div>
        </div>
        <div className="donut-stats">
          <div>
            <div className="n" style={{ color: "#17B26A" }}>{answeredCount}</div>
            <div className="l">Answered</div>
          </div>
          <div>
            <div className="n" style={{ color: "#C2255C" }}>{notAnsweredCount}</div>
            <div className="l">No answer</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnsweredPercentage;
